import { useContext, useState } from "react";
import { VAR_LIMIT } from "../../../../config/constant";
import { getDateFormat } from "../../../../helpers/helper";
import { patchUserProfile } from "../../../../services/httpService/userRequest";
import { updateUserDataValidator } from "../../../../validators/UserValidator";
import { GlobalContext } from "../../../contexts/globalContext";
import InputText from "../../atoms/InputText/InputText";
import Modal from "../../atoms/Modal/Modal";

let minDate = new Date();
minDate = minDate.setFullYear(minDate.getFullYear() - VAR_LIMIT.age.max);
minDate = getDateFormat(minDate);

const maxDate = getDateFormat(new Date());

const ModalUserData = (props) => {
  const [sharedState, dispatch] = useContext(GlobalContext);

  const [state, setState] = useState({
    isMale: sharedState.user.profile.isMale
      ? sharedState.user.profile.isMale
      : true,
    dateOfBirth: sharedState.user.profile.dateOfBirth
      ? getDateFormat(sharedState.user.profile.dateOfBirth)
      : "",
    height: sharedState.user.profile.height
      ? sharedState.user.profile.height
      : "",
    weight: sharedState.user.profile.weight
      ? sharedState.user.profile.weight
      : "",
  });

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "isMale") {
      value = value === "male" ? true : false;
    }
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleClose = (updatedProfile) => {
    const dataState = updatedProfile
      ? {
          isMale: updatedProfile.isMale,
          // age: updatedProfile.age,
          dateOfBirth: updatedProfile.dateOfBirth,
          height: updatedProfile.height,
          weight: updatedProfile.weight,
        }
      : {
          isMale: sharedState.user.profile.isMale
            ? sharedState.user.profile.isMale
            : true,
          // age: sharedState.user.profile.age ? sharedState.user.profile.age : "",
          dateOfBirth: sharedState.user.profile.dateOfBirth
            ? getDateFormat(sharedState.user.profile.dateOfBirth)
            : "",
          height: sharedState.user.profile.height
            ? sharedState.user.profile.height
            : "",
          weight: sharedState.user.profile.weight
            ? sharedState.user.profile.weight
            : "",
        };
    setState(dataState);
    if (props.handleClose) props.handleClose();
  };

  const handleSubmit = async () => {
    try {
      const data = {
        isMale: state.isMale,
        dateOfBirth: state.dateOfBirth,
        weight: state.weight,
        height: state.height,
      };
      const { error } = await updateUserDataValidator(data);
      console.dir(error);
      if (error) throw new Error(error.details[0].message);

      dispatch("isLoading", true);
      await patchUserProfile({
        ...data,
        _id: sharedState.user._id,
      });

      dispatch("isLoading", false);

      let updatedProfile = { ...sharedState.user.profile, ...state };
      dispatch("user", { profile: updatedProfile });
      handleClose(updatedProfile);
    } catch (error) {
      dispatch("alert", {
        type: "warning",
        message: error.message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };

  return (
    <Modal
      show={props.show}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    >
      <div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Jenis Kelamin</div>
          <select
            className="appereance-none col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 focus:bg-opacity-30 text-gray-700 text-opacity-70 px-2 py-1 rounded-lg focus:outline-none "
            name="isMale"
            value={state.isMale === true ? "male" : "female"}
            onChange={handleChange}
          >
            <option value="male">Laki-laki</option>
            <option value="female">Perempuan</option>
          </select>
        </div>

        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Tanggal Lahir</div>
          <InputText
            type="date"
            className="col-span-12 sm:col-span-9 "
            placeholder="yyyy-mm-dd"
            name="dateOfBirth"
            value={state.dateOfBirth}
            onChange={handleChange}
            min={minDate}
            max={maxDate}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Berat Badan (kg)</div>
          <InputText
            type="number"
            className="col-span-12 sm:col-span-9"
            name="weight"
            placeholder="Berat Badan (kg)"
            value={state.weight}
            onChange={handleChange}
            min={VAR_LIMIT.weight.min}
            max={VAR_LIMIT.weight.max}
          />
        </div>
        <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
          <div className="col-span-12 sm:col-span-3">Tinggi Badan (cm)</div>
          <InputText
            type="number"
            className="col-span-12 sm:col-span-9"
            name="height"
            placeholder="Tinggi Badan (cm)"
            value={state.height}
            onChange={handleChange}
            min={VAR_LIMIT.height.min}
            max={VAR_LIMIT.height.max}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalUserData;
